import { call, select, take } from 'redux-saga/effects'
import { SET_SKIPFEATURE } from '../redux/constants'
import Timeout from './Timeout'

function getTimePromise(time) {
  return new Promise(resolve => new Timeout(resolve, time))
}

/**
 * Generator function that will add a delay that will be paused
 * if the game gets paused.
 * @param {number} time - How long (in milliseconds) the delay will at least last.
 */
export default function* gameDelay(time) {
  const { stepDebug, skipfeature } = yield select(state => state.base)

  if (stepDebug) {
    if (!skipfeature) {
      yield take(SET_SKIPFEATURE)
    }
  } else {
    yield call(getTimePromise, time)
  }
}
